(function(ns) {
	"use strict";

	var util = ns.util;

	var defaultPosition = {lat: 36.594600, lng: 136.625747}; // 石川県庁
	var defaultZoom = 16;

	util.component("static-map", {
		props: {
			lat: {
				type: Number,
				default: 0,
			},
			lng: {
				type: Number,
				default: 0,
			},
			zoom: {
				type: Number,
				default: 16,
			},
			width: {
				type: Number,
				default: 240,
			},
			height: {
				type: Number,
				default: 240,
			},
		},
	});

})(CE);
